var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -14)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(9 14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(14 14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(19 14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotThree);
export default __webpack_public_path__ + "static/media/dot-three.a5bf5c3be11fcaa72784712d8c835dd4.svg";
export { ForwardRef as ReactComponent };